import { LandingLayout } from 'layouts';
import { ContentLeft, Footer, Header, type HeaderItem, PrivacyPolicy } from 'features/onboarding';
import { useIsAuthenticated } from '../../features/auth/storages';
import { useOnSuccessLogin, useOnboardingNavigation } from '../hooks';
import type { OnboardingLocationState } from '../types';

export type PrivacyPolicyLocationState = OnboardingLocationState;

const PagePrivacyPolicy = () => {
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onSuccessLogin } = useOnSuccessLogin<PrivacyPolicyLocationState>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin } = useOnboardingNavigation<PrivacyPolicyLocationState>();

  const isAuthenticated = useIsAuthenticated();

  const headerButtons: HeaderItem[] = isAuthenticated
    ? [
        {
          label: 'Home',
          async onClick() {
            await onSuccessLogin();
          },
          type: 'primary',
        },
      ]
    : [
        {
          label: 'Log in',
          async onClick() {
            await onNavigateToPrimaryLogin();
          },
          type: 'primary',
        },
      ];

  return (
    <LandingLayout
      contentLeft={<ContentLeft />}
      contentRight={<PrivacyPolicy />}
      footer={<Footer />}
      header={<Header items={headerButtons} />}
    />
  );
};

export default PagePrivacyPolicy;
